import { Component, OnInit } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import {Location} from '@angular/common';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import { DashboardComponent } from '../dashboard.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class StatsComponent implements OnInit {

  SalesChartFromDate = new FormControl(moment());
  SalesChartToDate = new FormControl(moment());

  VATChartFromDate = new FormControl(moment());
  VATChartToDate = new FormControl(moment());

  CCPChartFromDate = new FormControl(moment());
  CCPChartToDate = new FormControl(moment());

  ClientsDebtFromDate = new FormControl(moment());
  ClientsDebtToDate = new FormControl(moment());

  SuppliersDebtFromDate = new FormControl(moment());
  SuppliersDebtToDate = new FormControl(moment());

  CreditDebitChartFromDate = new FormControl(moment());
  CreditDebitChartToDate = new FormControl(moment());

  loadingSalesChart:boolean;
  loadingVATChart:boolean;
  loadingCCPChart:boolean;
  loadingClientsDebt:boolean;

  public SalesChart: {[k: string]: any} = {};
  public VATChart: {[k: string]: any} = {};
  public CCPChart: {[k: string]: any} = {};
  public ClientsDebt: {[k: string]: any} = {};
  public SuppliersDebt: {[k: string]: any} = {};

  public CreditDebit: {[k: string]: any} = {};

  public Periods:any[];
  SalesChartFilter: {[k: string]: any} = {};
  VATChartFilter: {[k: string]: any} = {};
  CCPChartFilter: {[k: string]: any} = {};
  ClientsDebtFilter: {[k: string]: any} = {};
  SuppliersDebtFilter: {[k: string]: any} = {};
  CreditDebitChartFilter: {[k: string]: any} = {};

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _snackBar: MatSnackBar, private location: Location) {
    
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');
  
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

   }

   ClearPeriod(){
    this.SalesChartFilter.Period = null;
    this.VATChartFilter.Period = null;
    this.CCPChartFilter.Period = null;
    this.ClientsDebtFilter.Period = null;
    this.SuppliersDebtFilter.Period = null;
    this.CreditDebitChartFilter.Period = null;
  }

  DisablePeriod(){
    this.SalesChartFilter.Period = null;
    this.VATChartFilter.Period = null;
    this.CCPChartFilter.Period = null;
    this.ClientsDebtFilter.Period = null;
    this.SuppliersDebtFilter.Period = null;
    this.CreditDebitChartFilter.Period = null;
  }

  ngOnInit(): void {
    this.SalesChartFilter.FromDate = null;
    this.SalesChartFilter.ToDate = null;

    this.VATChartFilter.FromDate = null;
    this.VATChartFilter.ToDate = null;

    this.CCPChartFilter.FromDate = null;
    this.CCPChartFilter.ToDate = null;
    this.CCPChart.DisplayOnlyInMainCurrency = true;

    this.ClientsDebtFilter.FromDate = null;
    this.ClientsDebtFilter.ToDate = null;

    this.SuppliersDebtFilter.FromDate = null;
    this.SuppliersDebtFilter.ToDate = null;

    this.CreditDebitChartFilter.FromDate = null;
    this.CreditDebitChartFilter.ToDate = null;

    this.ClientsDebt.DisplayOnlyInMainCurrency = true;

    this.ClientsDebtFilter.Pager = {};
    this.ClientsDebtFilter.Pager.PageIndex = 1;
    this.ClientsDebtFilter.Pager.PageSize = 10;

    this.SuppliersDebtFilter.Pager = {};
    this.SuppliersDebtFilter.Pager.PageIndex = 1;
    this.SuppliersDebtFilter.Pager.PageSize = 10;

    this.CreditDebitChartFilter.Pager = {};
    this.CreditDebitChartFilter.Pager.PageIndex = 1;
    this.CreditDebitChartFilter.Pager.PageSize = 10;

    this.SalesChart.DisplayOnlyInMainCurrency = true;

    this.GetAccountingMasterData();
    this.GetCompanyHealthStatus();
  }

  GetAllStats(){
    this.GetSalesCharts();
    this.GetVATChart();
    this.GetCCPChart();
    this.GetClientsDebt();
    this.GetSuppliersDebt();
    this.GetCreditDebitChart();
  }

  GetSalesCharts(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.SalesChartFilter,
      DisplayOnlyInMainCurrency:this.SalesChart.DisplayOnlyInMainCurrency
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.SalesChartFromDate.value._d.toLocaleDateString()));
      this.SalesChartFilter.FromDate = JSON.parse(JSON.stringify(this.SalesChartFromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.SalesChartToDate.value._d.toLocaleDateString()));
      this.SalesChartFilter.ToDate = JSON.parse(JSON.stringify(this.SalesChartToDate.value._d.toLocaleDateString()));
    }
    
   this.loadingSalesChart = true;
  
   this.service.GetSalesCharts(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.SalesChart = response["SalesChart"];
      this.SalesChartFromDate = new FormControl(moment(this.SalesChartFilter.FromDate));
      this.SalesChartToDate = new FormControl(moment(this.SalesChartFilter.ToDate));
     }
  
     this.loadingSalesChart = false;
   });
  }

  GetVATChart(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.VATChartFilter,
      DisplayOnlyInMainCurrency:true
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.VATChartFromDate.value._d.toLocaleDateString()));
      this.VATChartFilter.FromDate = JSON.parse(JSON.stringify(this.VATChartFromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.VATChartToDate.value._d.toLocaleDateString()));
      this.VATChartFilter.ToDate = JSON.parse(JSON.stringify(this.VATChartToDate.value._d.toLocaleDateString()));
    }
  
    this.loadingVATChart = true;
  
   this.service.GetVATChart(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.VATChart = response["SalesChart"];
      this.VATChartFromDate = new FormControl(moment(this.VATChartFilter.FromDate));
      this.VATChartToDate = new FormControl(moment(this.VATChartFilter.ToDate));
     }
  
     this.loadingVATChart = false;
   });
  }

  GetCCPChart(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.CCPChartFilter,
      DisplayOnlyInMainCurrency:this.CCPChart.DisplayOnlyInMainCurrency
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.CCPChartFromDate.value._d.toLocaleDateString()));
      this.CCPChartFilter.FromDate = JSON.parse(JSON.stringify(this.CCPChartFromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.CCPChartToDate.value._d.toLocaleDateString()));
      this.CCPChartFilter.ToDate = JSON.parse(JSON.stringify(this.CCPChartToDate.value._d.toLocaleDateString()));
    }
  
    this.loadingCCPChart = true;
  
   this.service.GetCCPChart(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.CCPChart = response["SalesChart"];
      this.CCPChartFromDate = new FormControl(moment(this.CCPChartFilter.FromDate));
      this.CCPChartToDate = new FormControl(moment(this.CCPChartFilter.ToDate));
     }
  
     this.loadingCCPChart = false;
   });
  }

  GetClientsDebt(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.ClientsDebtFilter,
      DisplayOnlyInMainCurrency:this.ClientsDebt.DisplayOnlyInMainCurrency
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.ClientsDebtFromDate.value._d.toLocaleDateString()));
      this.ClientsDebtFilter.FromDate = JSON.parse(JSON.stringify(this.ClientsDebtFromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ClientsDebtToDate.value._d.toLocaleDateString()));
      this.ClientsDebtFilter.ToDate = JSON.parse(JSON.stringify(this.ClientsDebtToDate.value._d.toLocaleDateString()));
    }
  
    this.loadingClientsDebt = true;
  
   this.service.GetClientsDebt(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.ClientsDebt = response["ProgressBarMasterChartModel"];
      this.ClientsDebtFromDate = new FormControl(moment(this.ClientsDebtFilter.FromDate));
      this.ClientsDebtToDate = new FormControl(moment(this.ClientsDebtFilter.ToDate));
     }
  
     this.loadingClientsDebt = false;
   });
  }

  GetSuppliersDebt(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.SuppliersDebtFilter,
      DisplayOnlyInMainCurrency:this.SuppliersDebt.DisplayOnlyInMainCurrency
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.SuppliersDebtFromDate.value._d.toLocaleDateString()));
      this.SuppliersDebtFilter.FromDate = JSON.parse(JSON.stringify(this.SuppliersDebtFromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.SuppliersDebtToDate.value._d.toLocaleDateString()));
      this.SuppliersDebtFilter.ToDate = JSON.parse(JSON.stringify(this.SuppliersDebtToDate.value._d.toLocaleDateString()));
    }
  
    this.loadingClientsDebt = true;
  
   this.service.GetSuppliersDebt(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.SuppliersDebt = response["ProgressBarMasterChartModel"];
      this.SuppliersDebtFromDate = new FormControl(moment(this.SuppliersDebtFilter.FromDate));
      this.SuppliersDebtToDate = new FormControl(moment(this.SuppliersDebtFilter.ToDate));
     }
  
     this.loadingClientsDebt = false;
   });
  }

  loadingCreditDebit:boolean;

  GetCreditDebitChart(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.CreditDebitChartFilter,
      DisplayOnlyInMainCurrency:this.CreditDebit.DisplayOnlyInMainCurrency
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.CreditDebitChartFromDate.value._d.toLocaleDateString()));
      this.CreditDebitChartFilter.FromDate = JSON.parse(JSON.stringify(this.CreditDebitChartFromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.CreditDebitChartToDate.value._d.toLocaleDateString()));
      this.CreditDebitChartFilter.ToDate = JSON.parse(JSON.stringify(this.CreditDebitChartToDate.value._d.toLocaleDateString()));
    }
  
    this.loadingCreditDebit = true;
  
   this.service.GetCreditDebitChart(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.CreditDebit = response["CreditDebitChart"];
      this.CreditDebitChartFromDate = new FormControl(moment(this.CreditDebitChartFilter.FromDate));
      this.CreditDebitChartToDate = new FormControl(moment(this.CreditDebitChartFilter.ToDate));
     }
  
     this.loadingCreditDebit = false;
   });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  GetAccountingMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetAccountingMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Periods = response["Periods"];
        this.SalesChartFilter.Period = this.Periods[2];
        this.VATChartFilter.Period = this.Periods[3];
        this.CCPChartFilter.Period = this.Periods[3];
        this.ClientsDebtFilter.Period = this.Periods[3];
        this.SuppliersDebtFilter.Period = this.Periods[3];
        this.CreditDebitChartFilter.Period = this.Periods[3];
        this.GetAllStats();
      }

      this.parent.loading = false;
    });

  }

  GetCompanyHealthStatus(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetCompanyHealthStatus(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
       var Company = response["Company"];
       this.parent.Company.Banks = Company.Banks;
       this.parent.Company.SMTPConfigs = Company.SMTPConfigs;
       this.parent.Company.PartnerCurrencies = Company.PartnerCurrencies;
       this.parent.Company.Health = Company.Health;
      }

      this.parent.loading = false;
    });

  }

}
